import type { CampaignEditTimeRestriction, ManagerGetCampaignModel } from 'entities/campaign';

import { BUDGET_SPENT_THRESHOLD_100, BUDGET_SPENT_THRESHOLD_80 } from './constants';
import type { AlertTextType, StatusTextType } from './interfaces';

const statusTextContractor: StatusTextType = {
  deactivatedExternal: {
    header: '80%+ of campaign budget is spent',
    subText: null,
    showIncreaseBudgetBtnBtn: true,
  },
  deactivatedOverbudgetExternal: {
    header: 'Campaign is Overbudget',
    subText: null,
    showIncreaseBudgetBtnBtn: true,
  },
  runningExternalWorking: {
    header: '80% of campaign budget is spent',
    subText:
      'Campaign budget has almost been reached this week. You can increase your budget and the effect will take place immediately.',
    showIncreaseBudgetBtnBtn: true,
  },
  overbudgetExternalWorking: {
    header: 'Campaign is Overbudget',
    subText:
      'Campaign budget has been reached this week. You can increase your budget and the effect will take place immediately.',
    showIncreaseBudgetBtnBtn: true,
  },
  runningExternalNotWorking: {
    header: '80%+ of campaign budget is spent',
    subText:
      'Campaign budget has almost been reached this week. You can increase your budget and the effect will take place immediately.',
    showIncreaseBudgetBtnBtn: true,
  },
  overbudgetExternalNotWorking: {
    header: 'Campaign is Overbudget',
    subText:
      'Campaign budget has been reached this week. You can increase your budget and the effect will take place immediately.',
    showIncreaseBudgetBtnBtn: true,
  },
  defaultSpent: {
    header: '80%+ of campaign budget is spent',
    subText:
      'An email will be sent automatically to the contractor so they can increase their campaign budget. Changes will take effect immediately.',
  },
};

export interface GetAlertContractor {
  spentToBudgetPercent: number;
  status: ManagerGetCampaignModel['status'];
  campaignEditRestriction: CampaignEditTimeRestriction['campaignEditTimeRestriction'];
}

export const getAlertTextContractor = ({
  status,
  spentToBudgetPercent,
  campaignEditRestriction,
}: GetAlertContractor): AlertTextType => {
  const editingAllowed = campaignEditRestriction?.isEditingAllowed;

  if (status === 'budgetReached' && spentToBudgetPercent >= BUDGET_SPENT_THRESHOLD_100 && editingAllowed) {
    return statusTextContractor.overbudgetExternalWorking;
  }

  if (
    (status === 'running' || status === 'paused') &&
    spentToBudgetPercent >= BUDGET_SPENT_THRESHOLD_80 &&
    editingAllowed
  ) {
    return statusTextContractor.runningExternalWorking;
  }

  if (status === 'budgetReached' && spentToBudgetPercent >= BUDGET_SPENT_THRESHOLD_100 && !editingAllowed) {
    return statusTextContractor.overbudgetExternalNotWorking;
  }
  if (
    (status === 'running' || status === 'paused') &&
    spentToBudgetPercent >= BUDGET_SPENT_THRESHOLD_80 &&
    !editingAllowed
  ) {
    return statusTextContractor.runningExternalNotWorking;
  }

  if (status === 'deactivated' && spentToBudgetPercent >= BUDGET_SPENT_THRESHOLD_100) {
    return statusTextContractor.deactivatedOverbudgetExternal;
  }

  if (status === 'deactivated') {
    return statusTextContractor.deactivatedExternal;
  }

  return statusTextContractor.defaultSpent;
};
